import { render, staticRenderFns } from "./BosquesCasas.vue?vue&type=template&id=2d71c056"
import script from "./BosquesCasas.vue?vue&type=script&lang=js"
export * from "./BosquesCasas.vue?vue&type=script&lang=js"
import style0 from "./BosquesCasas.vue?vue&type=style&index=0&id=2d71c056&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports